import create from 'zustand'
import { devtools } from 'zustand/middleware'
import immer from "./immer"
let useDegreeStore = (set) => ({
    degrees: [],
    addDegree: (deg) => set((state) => void (state.degrees.push(deg))),
    addAllDegrees: (degs) => set((state) => void (state.degrees = degs))
});
useDegreeStore = devtools(useDegreeStore, { name: "degrees" });
useDegreeStore = immer(useDegreeStore);
export default create(useDegreeStore);
